import React from 'react';
import TagSelection from '../../../../../../components/Tag/TagSelection';
import {Form, useUpdateFormProspectTagsMutation} from 'api';

interface Props {
  form: Form;
}

export default ({form}: Props) => {
  const [, setTagName] = React.useState('');
  const [tags, setTags] = React.useState(
    form.prospectTags.map((t) => ({id: t.id, name: t.name})),
  );

  const [update] = useUpdateFormProspectTagsMutation({
    onCompleted: ({
      updateFormProspectTags: {form: {prospectTags = []} = {}} = {},
    }) => {
      setTagName('');
      setTags(prospectTags.map((t) => ({id: t.id, name: t.name})));
    },
  });

  return <TagSelection entity={form} update={update} tags={tags} />;
};
